import React, { useContext } from "react";
import ListItemText from "@material-ui/core/ListItemText";
import { StyledMenu, StyledMenuItem } from "../../../../../components/Menu/StyledMenu";
import { TestSeriesContext } from "../../../../../contexts/TestSeriesContext";

export interface SquareProps {
  testSeriesId: number;
  substrateSectionCount: number;
  anchor: null | HTMLElement;
  handleClose: () => void;
}

function TestSeriesRegainMenu(props: SquareProps) {
  const { anchor, handleClose, substrateSectionCount, testSeriesId } = props;
  const { setIsMethodDialogOpen, updateRegainConfig } = useContext(TestSeriesContext);

  const onClickRegainedSubstrate = (regainFirstSubstrateSection: boolean, regainSecondSubstrateSection: boolean) => {
    handleClose();
    updateRegainConfig({
      originalTestSeriesId: testSeriesId,
      regainConfig: "SUBSTRATES",
      regainFirstSubstrateSection,
      regainSecondSubstrateSection,
    });
    setIsMethodDialogOpen(true);
  };

  return (
    <StyledMenu id="customized-menu" anchorEl={anchor} keepMounted open={Boolean(anchor)} onClose={handleClose}>
      {substrateSectionCount === 0 && (
        <StyledMenuItem
          onClick={() => {
            handleClose();
          }}
        >
          <ListItemText primary="No action possible" />
        </StyledMenuItem>
      )}
      {substrateSectionCount === 1 && (
        <StyledMenuItem
          onClick={() => {
            onClickRegainedSubstrate(true, false);
          }}
        >
          <ListItemText primary="Reuse Regained Substrate Samples" />
        </StyledMenuItem>
      )}
      {substrateSectionCount === 2 && (
        <>
          <StyledMenuItem
            onClick={() => {
              onClickRegainedSubstrate(true, false);
            }}
          >
            <ListItemText primary="Reuse Regained Substrate Samples 1" />
          </StyledMenuItem>
          <StyledMenuItem
            onClick={() => {
              onClickRegainedSubstrate(false, true);
            }}
          >
            <ListItemText primary="Reuse Regained Substrate Samples 2" />
          </StyledMenuItem>
          <StyledMenuItem
            onClick={() => {
              onClickRegainedSubstrate(true, true);
            }}
          >
            <ListItemText primary="Reuse Both Regained Substrate Samples" />
          </StyledMenuItem>
        </>
      )}
    </StyledMenu>
  );
}

export default TestSeriesRegainMenu;
